"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MagnifyingGlassCircleIcon = ({
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ...otherProps,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M57.34 61.035a1.827 1.827 0 113.654.002 1.827 1.827 0 01-3.654-.002",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M54.39 64.791a33.835 33.835 0 01-18.1 5.213c-18.776 0-33.998-15.222-33.998-34 0-18.777 15.222-34 33.999-34 18.776 0 34 15.223 34 34A33.842 33.842 0 0163.42 56.5",
        stroke: "#fefefe",
        strokeWidth: 3.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M51.05 48.554h0a3.675 3.675 0 01-5.197 0l-5.934-5.833 2.64-2.556 8.49 8.39z",
        stroke: "#4caa50",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M33.345 22.504c6.105 0 11.054 4.949 11.054 11.054S39.449 44.61 33.345 44.61c-6.105 0-11.054-4.948-11.054-11.053s4.949-11.054 11.054-11.054zM34.27 27.095a5.408 5.408 0 015.407 5.408",
        stroke: "#4caa50",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      })]
    })]
  });
};

MagnifyingGlassCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(MagnifyingGlassCircleIcon);

exports.default = _default;